import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { PhoneSelectFormikField } from '../../../../Phone'
import { USER_FORM_FIELD_NAME_PHONE } from '../../../../User'

function PhoneField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <PhoneSelectFormikField
      controlProps={{
        borderless: !isMobileScreenSize,
      }}
      fieldComponentProps={{
        label: `${t('Inhabitant.PhoneLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={USER_FORM_FIELD_NAME_PHONE}
    />
  )
}

export default PhoneField
